/**
 * The base URL of the main API.
 */
export const API_URL = import.meta.env.VITE_API_URL;

/**
 * The public API key for Google Maps.
 */
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

/**
 * The URL for the extended Google Maps component library.
 */
export const GOOGLE_MAPS_EXTENDED_LIBRARY_URL = import.meta.env.VITE_GOOGLE_MAPS_EXTENDED_LIBRARY_URL;

/**
 * The specific Map ID for Google Maps.
 */
export const GOOGLE_MAPS_MAP_ID = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID;

/**
 * The solution channel for Google Maps.
 */
export const GOOGLE_MAPS_SOLUTION_CHANNEL = import.meta.env.VITE_GOOGLE_MAPS_SOLUTION_CHANNEL;
/**
 * The GCS bucket Origin.
 */
// this is static for now, cause we know our storage origin is gcp
export const STORAGE_ORIGIN_URL = 'https://storage.googleapis.com'; // import.meta.env.VITE_STORAGE_ORIGIN_URL;
/**
 * The name of the GCS bucket used for serving assets.
 */
export const ASSETS_BUCKET = import.meta.env.VITE_ASSETS_BUCKET;

/**
 * The name of the GCS bucket used for serving public content.
 */
export const SERVE_BUCKET = import.meta.env.VITE_SERVE_BUCKET;

/**
 * The origin URL for the GCS buckets.
 */
export const BUCKET_ORIGIN_URL = import.meta.env.VITE_BUCKET_ORIGIN_URL;

/**
 * The public key for Stripe.
 */
export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY;

/**
 * The share service url.
 */
export const SHARE_URL = import.meta.env.VITE_SHARE_URL;

export const PULSE_URL = import.meta.env.VITE_PULSE_URL;
